import './ShippingAdmin.less';
import { useMount } from 'ahooks';
import { Tabs, Layout } from 'antd';
import { useAppDispatch } from 'app/hooks';
import { useOrgId } from 'hooks/useOrg';
import { useTranslation } from 'react-i18next';
import ShippingAddressForm from './ShippingAddressForm';
import InternalDistribution from './InternalDistribution';
import ManageDisplay from './ManageDisplay';
import Carriers from './Carriers';
import NoCarrierShippingOption from './NoCarrierShippingOption';
import ShippingAccounts from './ShippingAccounts';

const { TabPane } = Tabs;

const ShippingAdmin = () => {
  const { t } = useTranslation();
  const {
    shipping,
    app: { showLoading, hideLoading },
  } = useAppDispatch();
  const orgId = useOrgId();

  useMount(async () => {
    if (orgId) {
      showLoading();
      await shipping.getOrgShippingConfig(orgId);
      hideLoading();
    }
  });

  return (
    <div className="shipping-admin">
      <Tabs tabPosition="left" defaultActiveKey="manageDisplay">
        <TabPane key="manageDisplay" tab={t('platform.shipping.manageDisplay')}>
          <ManageDisplay />
        </TabPane>
        <TabPane key="carriers" tab={t('platform.shipping.carriers')}>
          <div>
            <Layout.Content>
              <Carriers />
            </Layout.Content>
          </div>
        </TabPane>
        <TabPane
          key="NoCarrier"
          tab={t('platform.shipping.noCarrierShippingOption')}
        >
          <NoCarrierShippingOption />
        </TabPane>
        <TabPane
          key="ShippingAccounts"
          tab={t('platform.shipping.ShippingAccounts')}
        >
          <ShippingAccounts />
        </TabPane>
        <TabPane
          key="shippingAddress"
          tab={t('platform.shipping.shippingAddress')}
        >
          <div>
            <Layout.Content>
              <ShippingAddressForm />
            </Layout.Content>
          </div>
        </TabPane>
        <TabPane
          key="InternalDistribution"
          tab={t('platform.shipping.InternalDistribution')}
        >
          <div>
            <div className="title mb-20">
              {t('platform.shipping.InternalDistribution')}
            </div>
            <Layout.Content>
              <InternalDistribution />
            </Layout.Content>
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
};

export default ShippingAdmin;
